import { svg } from "lit";
const icon = svg `<path d="M12.9462 11.9995L8.34619 7.39953L9.40002 6.3457L15.0538 11.9995L9.40002 17.6534L8.34619 16.5995L12.9462 11.9995Z" fill="currentColor"/>`;
export default icon;
